export const SET_AGENDAS = "AGENDAS/SET_AGENDAS";
export const SET_AGENDA = "AGENDAS/SET_AGENDA";
export const SET_ITEM_AGENDA = "AGENDAS/SET_ITEM_AGENDA";
export const SET_ITEMS_AGENDA = "AGENDAS/SET_ITEMS_AGENDA";
export const SET_PAGINATION = "AGENDAS/SET_PAGINATION";
